import { cloneElement } from "react";

const StoresList = ({ storesData, children }) => (
  <ul>
    {storesData.map((store, index) => (
      <li
        key={store.id}
        className={`${index > 0 ? "border-t border-[#E6E6E6]" : ""} py-[20px]`}
      >
        {cloneElement(children, {
          storeData: store,
        })}
      </li>
    ))}
  </ul>
);

export default StoresList;
